/**
 * @file     footerCopy.ts
 * @purpose  MessageRef catalog for footer text: description title, description body, and trust phrase.
 */
import { messageRef } from '../messageRef';

export const footerCopy = {
  descriptionTitle: messageRef('footer.descriptionTitle'),
  description: messageRef('footer.description'),
  trustPhrase: messageRef('footer.trustPhrase'),
} as const;
